<div class="ts-card">
    <div class="page-header">
        <h2 class="ts-card-title page-title">Today's Allocations</h2>
        <button class="btn-primary" type="button" (click)="loadAllocations()">
            <fa-icon [icon]="faRotate"></fa-icon>
            Refresh
        </button>
    </div>
    <ng-container *ngIf="!loading && searchExecuted">
        <ng-container *ngIf="totalRecords > 0; else noRecordsFound">
            <table class="ts-table">
                <thead>
                    <tr>
                        <th class="medium-column header-vertical-border text-right-numeric">Allocation Id</th>
                        <th class="header-vertical-border">Symbol</th>
                        <th class="header-vertical-border">Side</th>
                        <th class="header-vertical-border text-right-numeric">Average Price</th>
                        <th class="header-vertical-border text-right-numeric">Total Quantity</th>
                        <th class="header-vertical-border text-right-numeric">Total Value</th>
                        <th class="header-vertical-border">Allocated By</th>
                        <th class="header-vertical-border">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let allocation of pagedElements$ | async">
                        <tr class="element-row" (click)="toggleRow(allocation)" [class.expanded-row]="allocation.expanded">
                            <td class="medium-column text-right-numeric">
                                <fa-icon *ngIf="!allocation?.expanded" [icon]="faPlus"></fa-icon>
                                <fa-icon *ngIf="allocation?.expanded" [icon]="faMinus"></fa-icon>
                                {{allocation.orderDetail[0].allocationId}}
                            </td>
                            <td>{{ allocation.symbol }}</td>
                            <td>{{ allocation.side }}</td>
                            <td class="text-right-numeric">{{ allocation.avgPrice | currency:'USD':'symbol':'1.2-2' }}</td>
                            <td class="text-right-numeric">{{ allocation.totalQuantity }}</td>
                            <td class="text-right-numeric">{{ allocation.totalValue | currency:'USD':'symbol':'1.2-2' }}</td>
                            <td>{{ allocation.user }}</td>
                            <td>
                                <button class="btn-danger" (click)="undoAllocation($event, allocation)"
                                    title="Click on 'Undo' to undo the allocation">Undo</button>
                            </td>
                        </tr>
                        <tr class="detail-row" *ngIf="allocation.expanded">
                            <td [attr.colspan]="displayedColumns.length">
                                <div class="element-detail">
                                    <!-- Order Details Table -->
                                    <table class="ts-table inner-table">
                                        <thead>
                                            <tr>
                                                <th class="header-vertical-border text-right-numeric">Order #</th>
                                                <th class="header-vertical-border">Symbol</th>
                                                <th class="header-vertical-border">Side</th>
                                                <th class="header-vertical-border text-right-numeric">Executed Price</th>
                                                <th class="header-vertical-border text-right-numeric">Quantity Allocated</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let detail of allocation.orderDetail">
                                                <td class="text-right-numeric">{{ detail.orderId }}</td>
                                                <td>{{ detail.symbol }}</td>
                                                <td>{{ detail.side }}</td>
                                                <td class="text-right-numeric">{{ detail.execPrice | currency:'USD':'symbol':'1.2-2' }}</td>
                                                <td class="text-right-numeric">{{ detail.execQuantity }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <hr class="section-divider">
                                    <!-- Allocation Details Table -->
                                    <table class="ts-table inner-table">
                                        <thead>
                                            <tr>
                                                <th class="header-vertical-border text-right-numeric">Account ID</th>
                                                <th class="header-vertical-border">Symbol</th>
                                                <th class="header-vertical-border">Side</th>
                                                <th class="header-vertical-border text-right-numeric">Price</th>
                                                <th class="header-vertical-border text-right-numeric">Quantity</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let detail of allocation.allocationDetails">
                                                <td class="text-right-numeric">{{ detail.accountId }}</td>
                                                <td>{{ detail.symbol }}</td>
                                                <td>{{ detail.side }}</td>
                                                <td class="text-right-numeric">{{ detail.price | currency:'USD':'symbol':'1.2-2' }}</td>
                                                <td class="text-right-numeric">{{ detail.quantity }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>

            <app-paginator style="margin-top: 10px;" [length]="totalRecords" [pageSize]="pageSize" [pageIndex]="pageIndex"
                (page)="pageChangeEvent($event)" [pageSizeOptions]="[25, 50, 100, 500]"
                *ngIf="totalRecords > 0 && !loading"></app-paginator>
        </ng-container>
    </ng-container>

    <ng-template #noRecordsFound>
        <app-empty-state
            [icon]="faScaleBalanced"
            headline="No allocations today"
            hint="No trades have been allocated today. Use Refresh to check again."></app-empty-state>
    </ng-template>
</div>
